module.exports = __webpack_public_path__ + "static/media/angular.5fb7f20e.png";